/**
 * @description Pack SO global settings shell (LYN-357, LYN-363, LYN-267)
 *
 * Key features:
 * - Empty settings-06 chrome: title + card, no fake tabs
 * - Connectors sub-nav when the CP flag is on
 * - Does not follow the company dropdown
 *
 * @dependencies layouts/so/PackPage, soConnectorsApi
 *
 * @notes No Time Clock / PTO / Reporting. 289 and 358 stay out.
 */

import { useEffect, useState } from 'react';
import PackPage from '../../components/layouts/so/PackPage';
import { listSoConnectors } from '../../services/api/soConnectorsApi';

export default function SoSettingsPage() {
  const [hasConnectors, setHasConnectors] = useState(false);

  useEffect(() => {
    let cancelled = false;
    listSoConnectors()
      .then((res) => {
        if (!cancelled) setHasConnectors((res.data || []).length > 0);
      })
      .catch(() => {
        if (!cancelled) setHasConnectors(false);
      });
    return () => { cancelled = true; };
  }, []);

  const items = hasConnectors
    ? [
      { key: 'settings', label: 'Settings', to: '/so/settings' },
      { key: 'connectors', label: 'Connectors', to: '/so/settings/connectors' }
    ]
    : [];

  return (
    <PackPage
      title="Settings"
      subtitle="Organization-wide settings. This page does not change with the company dropdown."
      items={items}
    >
      <div className="bg-white rounded-xl border border-gray-200 min-h-[20rem]" />
    </PackPage>
  );
}
